import { defineSlotRecipe } from '@chakra-ui/react'
import { tableAnatomy } from '@chakra-ui/react/anatomy'

export const tableSlotRecipe = defineSlotRecipe({
    slots: tableAnatomy.keys(),
    variants: {
        variant: {
            gsktable: {
                header: {
                    borderBottomWidth: '2px',
                    borderBottomColor: 'gray.300',
                    borderBottomStyle: 'solid',
                    tr: {
                        th: {
                            fontSize: '14px',
                            fontWeight: 'boldmt',
                            letterSpacing: '0.25px',
                            lineHeight: '20px',
                            whiteSpace: 'break-spaces',
                            textAlign: 'center',
                            padding: '8px 16px 8px 16px',
                            position: 'relative',
                            _before: {
                                content: '""',
                                position: 'absolute',
                                top: '16.5%',
                                right: 0,
                                height: '66.67%',
                                width: '1px',
                                backgroundColor: 'gray.200',
                            },
                            _last: {
                                _before: {
                                    backgroundColor: 'transparent',
                                },
                            },
                        },
                    },
                },
                tbody: {
                    tr: {
                        _odd: {
                            background: 'rgba(255, 255, 255, 0.5)',
                        },
                        td: {
                            whiteSpace: 'break-spaces',
                            padding: '8px 16px 8px 16px',
                            position: 'relative',
                            fontSize: '14px',
                            letterSpacing: '0.25px',
                            lineHeight: '20px',
                            _before: {
                                content: '""',
                                position: 'absolute',
                                top: '16.5%',
                                right: 0,
                                height: '66.67%',
                                width: '1px',
                                backgroundColor: 'gray.200',
                            },
                            _last: {
                                _before: {
                                    backgroundColor: 'transparent',
                                },
                            },
                        },
                    },
                },
            },
        },
    },
})
